import { render, staticRenderFns } from "./OneOffSamplingCalculator.vue?vue&type=template&id=c20982aa"
import script from "./OneOffSamplingCalculator.vue?vue&type=script&lang=ts"
export * from "./OneOffSamplingCalculator.vue?vue&type=script&lang=ts"
import style0 from "./OneOffSamplingCalculator.vue?vue&type=style&index=0&id=c20982aa&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports